import axios from "axios";

const api = axios.create({
    baseURL:"https://695a9ee0950475ada4673ce1.mockapi.io"
    // https://695a9ee0950475ada4673ce1.mockapi.io/tickets
})
export default api;